import styled from 'styled-components';

export const HomeWrapper = styled.div`
.site-content, article{
    width: 100%;
    margin: auto;
    padding: 5px;
}
.text-align-left{
    text-align: left;
}
.text-align-justify{
    text-align: justify;
}
h4{
    font-size: 20px;
    font-size: 1.25rem;
    line-height: 1.2em;
}
h3{
    font-size: 24px;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.3em;
}
.entry-title {
    font-weight: 600;
    font-size: 1.8rem;
}
#header-img{
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
}
article{
    margin-top: -80px;
    z-index: 9;
    position: relative;
    border-radius: 4px;
    background-color: white;
    padding:25px;
}
body, h1, h2, h3, h4, h5, h6,p, .entry-title a {
    color: #334155;
}
.quote{
    font-size: 1.5em;
    font-style: italic;
    line-height: 1.6;
}
.alert{
    border: 1px solid black;
    border-width: initial;
}
.course{
    background: linear-gradient(135deg, rgb(255, 105, 0) 0%, rgb(207, 46, 46) 100%);
    border-style: none;
    margin: 0.5rem;
}
.course a {
    color: #fff;
    font-weight: 500;
    text-decoration: none;
}
.related-link a{
    color: #647f19;
    font-size: large;
}
.related-link{
    padding-bottom: 2vh;
}
`;
